// constants/configurationTabs.js
import { 
  BanknotesIcon, 
  UserIcon,
  // BellIcon,
  ShieldCheckIcon,
  // Cog6ToothIcon,
  // PresentationChartLineIcon,
  // EyeIcon
} from '@heroicons/react/24/outline';

export const TAB_IDS = {
  EMPLOYEES: 'employees',
  DEFAULTS: 'defaults',
  SYSTEM: 'system',
  NOTIFICATIONS: 'notifications',
  DISPLAY: 'display',
  MY_NOTIFICATIONS: 'my-notifications',
  NOTIFICATION_RULES: 'notification-rules',
  ACCESS: 'access'
};

export const getConfigurationTabs = (userRole) => {
  const baseTabs = [
    { 
      id: TAB_IDS.EMPLOYEES, 
      name: 'Employee Rates', 
      icon: UserIcon,
      type: 'custom' // Custom component (existing)
    },
    { 
      id: TAB_IDS.DEFAULTS, 
      name: 'Default Values', 
      icon: BanknotesIcon,
      type: 'settings', // Generic settings
      categoryKey: 'defaults' // Maps to SETTINGS_CONFIG.defaults
    },
    // { 
    //   id: TAB_IDS.SYSTEM, 
    //   name: 'System', 
    //   icon: Cog6ToothIcon,
    //   type: 'settings',
    //   categoryKey: 'system'
    // },
    // { 
    //   id: TAB_IDS.NOTIFICATIONS, 
    //   name: 'Notifications', 
    //   icon: BellIcon,
    //   type: 'settings',
    //   categoryKey: 'notifications'
    // },
    // { 
    //   id: TAB_IDS.DISPLAY, 
    //   name: 'Display', 
    //   icon: EyeIcon,
    //   type: 'settings',
    //   categoryKey: 'display'
    // },
    // { 
    //   id: TAB_IDS.MY_NOTIFICATIONS, 
    //   name: 'My Notifications', 
    //   icon: PresentationChartLineIcon,
    //   type: 'custom' // Custom component
    // },
  ];

  // Add admin-only tabs
  if (userRole === 'admin') {
    baseTabs.push({
      id: TAB_IDS.NOTIFICATION_RULES,
      name: 'Notification Rules',
      icon: ShieldCheckIcon,
      type: 'custom'
    });
  }

  return baseTabs;
};